import { FC, ReactElement } from 'react';

import localLogo from '../../assets/icons/header/platform/logo.svg';
import facebookIcon from '../../assets/icons/social/facebook.svg';
import linkedinIcon from '../../assets/icons/social/linkedin.svg';
import twitterIcon from '../../assets/icons/social/twitter.svg';
import { usePlatformData } from '../../features/home/hooks/usePlatformData';

const Footer: FC = (): ReactElement => {
    const { eventData } = usePlatformData();
    const displayLogo: string | undefined = localLogo || eventData?.logoUrl || undefined;

    return (
        <footer className="w-full bg-[#101828] h-[200px] flex flex-col justify-center px-[20px] min-[576px]:px-[24px]">
            <div className="w-full max-w-[350px] min-[576px]:max-w-[1240px] mx-auto flex flex-col gap-[16px] min-[576px]:gap-[32px]">
                
                {/* Top Row: Logo, Links, Socials */}
                <div className="flex flex-col md:flex-row items-center justify-between gap-4 md:gap-0">
                    
                    {/* Left: Logo & Links */}
                    <div className="flex flex-col md:flex-row items-center gap-[16px] md:gap-[32px]">
                        {/* Logo */}
                        {/* Logo */}
                        {displayLogo && (
                            <img 
                                src={displayLogo} 
                                alt="Event Logo" 
                                className="h-[32px] md:h-[40px] object-contain brightness-0 invert" 
                            />
                        )}

                        {/* Links */}
                        <nav className="flex items-center gap-[16px] md:gap-[24px] text-[10px] md:text-sm font-noto !bg-transparent !border-none !shadow-none !m-0 !p-0">
                            <a href="#" className="text-gray-300 !no-underline hover:text-white transition-colors !bg-transparent !border-none">Privacy</a>
                            <a href="#" className="text-gray-300 !no-underline hover:text-white transition-colors !bg-transparent !border-none">Terms</a>
                            <a href="#" className="text-gray-300 !no-underline hover:text-white transition-colors !bg-transparent !border-none">CCPA: Do not sell my personal info</a>
                        </nav>
                    </div>

                    {/* Right: Social Icons */}
                    <div className="flex items-center gap-[16px]">
                        <button className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                            <img src={twitterIcon} alt="X" className="w-4 h-4 brightness-0 invert" />
                        </button>
                        <button className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                            <img src={linkedinIcon} alt="LinkedIn" className="w-4 h-4 brightness-0 invert" />
                        </button>
                        <button className="w-8 h-8 rounded-full bg-white/10 flex items-center justify-center hover:bg-white/20 transition-colors">
                            <img src={facebookIcon} alt="Facebook" className="w-4 h-4 brightness-0 invert" />
                        </button>
                    </div>
                </div>

                {/* Bottom Row: Copyright */}
                <div className="w-full flex justify-center md:justify-start text-[#98A2B3] text-[9px] md:text-[11px] font-noto leading-[14px] md:leading-[18px] text-center md:text-left">
                    Copyright © 2025 Informa Limited. Registered in England & Wales with number 01835199, registered office 5 Howick Place, London, SW1P 1WG.
                </div>

            </div>
        </footer>
    );
};

export default Footer;
